/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Question24({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="24"
      role="img"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.24 9.79C8.27 7.42 9.75 6 12.19 6c2.04 0 3.57 1.34 3.57 3.11 0 1.53-.75 2.16-1.65 2.77-.063.046-.123.085-.18.123a4.995 4.995 0 0 0-.13.087l-.031.021c-.613.408-1.019.679-1.019 1.249v.19H10.8v-.31c0-1.17.66-1.69 1.53-2.25l.11-.07c.71-.48 1.27-.86 1.27-1.7 0-.29-.12-1.25-1.56-1.25-1.19 0-1.8.66-1.88 2l-.01.16-2.02-.2v-.14Zm4.82 5.51h-2.42v2.35h2.42V15.3Z"
        fill={CssVars.textColor}
      />
      <path
        clipRule="evenodd"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
